'use strict';

var angular = require('angular');

module.exports = function($scope, $rootScope, ParticipantService, $location) {
    $scope.page = 'start';
    $scope.sprite = '/images/sprites/boss/default.svg';
    $scope.showPopup = false;
    $scope.competition = $rootScope.competitionActive;
    $scope.competitionPartTwo = $rootScope.competitionPartTwo;

    $scope.gotoCompPage = function() {
        $scope.page = 'competition';
        $scope.sprite = '/images/sprites/boss/point.svg';
    };

    $scope.gotoCompPage2 = function() {
        $scope.page = 'competition2';
        $scope.sprite = '/images/sprites/boss/point.svg';
    };

    $scope.openPopup = function() {
        $scope.showPopup = true;
    };

    $scope.closePopup = function() {
        $scope.showPopup = false;
    };

    $scope.startGame = function() {
        if (window.location.search.match('doNotClear')) {
            $location.path('/prequiz');
            return;
        }

        ParticipantService.clearParticipant()
            .then(function(result) {
                $location.path('/prequiz');
            }, function(error) {
                $location.path('/prequiz');
            });
    };
};
